export const DOMAIN = "b2b.snusco.at";
export const SLUG = "at";
export const DEFAULT_LANGUAGE = "de";

export const MIN_QTY = (product) => (product?.state === "on_request" ? 40 : 10);

export const convertCurrency = (price, fromCurrency, toCurrency) => {
  if (fromCurrency === toCurrency) {
    return Math.round((parseFloat(price) + Number.EPSILON) * 1000) / 1000;
  }

  let exchangeRate = 1;

  const rates = {
    "EUR->USD": 1.1,
    "USD->EUR": 1 / 1.1,
  };

  const rateKey = `${fromCurrency}->${toCurrency}`;

  if (rates[rateKey]) {
    exchangeRate = rates[rateKey];
  }

  let convertedPrice = price * exchangeRate;

  // Zaokruživanje na 3 decimale
  return Math.round((convertedPrice + Number.EPSILON) * 1000) / 1000;
};

export const currencyTags = {
  USD: "$",
  EUR: "€",
};
export const DEFAULT_CURRENCY = "EUR";

export const PRODUCT_CHUNK = 30; // koliko se prozivoda prikazuje odjednom

//CHECKOUT
export const paymentMethods = [
  { name: "Cash on Delivery", code: "cod", available: true },
  { name: "Credit Card", code: "card", available: false },
  // { name: "PayPal", code: "paypal", available: false },
];

export const transportMethods = [
  //{ name: "DHL Standard", price: 8.9, days: 5 },
  { name: "Post - AT", code: "post_at", price: 12.0, days: 3 },
  //{ name: "DHL Express Saver", price: 19.9, days: 3 },
];

export const freeShippingThreshold = 50; // Prag za besplatnu dostavu

export const getTransportPrice = (method, totalQuantity) => {
  // Težina jedne jedinice: 0.033 kg
  const weight = totalQuantity * 0.033;

  const getSingleBoxPrice = (kg) => {
    if (kg <= 2) return 6;
    if (kg <= 4) return 7;
    if (kg <= 8) return 8;
    if (kg <= 12) return 9;
    if (kg <= 20) return 11;
    return 12; // max 31.5kg
  };

  // B2B logika: svaka kutija max 7.8kg, obračun po komadu
  const maxPerBox = 7.8;
  const fullBoxes = Math.floor(weight / maxPerBox);
  const remainder = weight % maxPerBox;

  let totalCost = fullBoxes * getSingleBoxPrice(maxPerBox);

  if (remainder > 0) {
    totalCost += getSingleBoxPrice(remainder);
  }

  return totalCost;
};

export const getShippingCostPrice = (
  selectedMethod,
  fromCurrency,
  toCurrency
) => {
  const method = transportMethods.find((m) => m.name === selectedMethod);
  const price = method ? method.price : 0; // Ako metoda nije pronađena, postavi cenu na 0
  return convertCurrency(price, fromCurrency, toCurrency);
};

export const languages = [
  {
    code: "de",
    label: "Deutsch",
    flag: require("../assets/icons/austria.svg").default,
  },
  {
    code: "en",
    label: "English",
    flag: require("../assets/icons/united-kingdom.svg").default,
  },
];

export const featured_categories = [
  { name: "Velo" },
  { name: "Skruf" },
  { name: "77" },
  { name: "Cuba" },
];
export const adminEmailList = [
  "djuricm13111@gmail.com",
  "djuricm888@gmail.com",
];

// export const getPriceByQuantity = ({
//   priceInfo,
//   quantity = null,
//   fromCurrency = DEFAULT_CURRENCY,
//   toCurrency = DEFAULT_CURRENCY,
// }) => {
//   if (!priceInfo) return null;

//   // Ako je direktna cena (akcijska ili custom)
//   if (priceInfo.price) {
//     return convertCurrency(priceInfo.price, fromCurrency, toCurrency);
//   }

//   // Ako su količinske cene (npr. StandardBrand ili CustomBrand)
//   if (priceInfo.quantity_prices && priceInfo.quantity_prices.length > 0) {
//     // Ako nije prosleđena količina, vrati najvišu cenu (najnižu količinu)
//     if (!quantity) {
//       return convertCurrency(
//         priceInfo.quantity_prices[0].price,
//         fromCurrency,
//         toCurrency
//       );
//     }

//     // Pronađi najveći `min_quantity` koji je manji ili jednak prosleđenoj količini
//     let matched = null;
//     for (let p of priceInfo.quantity_prices) {
//       if (quantity >= p.min_quantity) {
//         matched = p;
//       }
//     }

//     // Ako nađeno, konvertuj i vrati
//     if (matched) {
//       return convertCurrency(matched.price, fromCurrency, toCurrency);
//     }

//     // Ako nijedna količina ne odgovara, vrati prvu kao fallback
//     return convertCurrency(
//       priceInfo.quantity_prices[0].price,
//       fromCurrency,
//       toCurrency
//     );
//   }

//   return null;
// };

export const getPriceByQuantity = ({
  priceInfo,
  quantity = null, // više se ne koristi
  fromCurrency = DEFAULT_CURRENCY,
  toCurrency = DEFAULT_CURRENCY,
}) => {
  if (!priceInfo || typeof priceInfo.price !== "number") {
    return null;
  }
  return convertCurrency(priceInfo.price, fromCurrency, toCurrency);
};
